module.exports = __webpack_public_path__ + "img/mycolour-vertical.4af4f551.png";